export default __webpack_public_path__ + "static/media/Group 11289.b1704413.png";